export default function DirectAnswerBlock() {
  return <section id="direct-answer-block" className="bg-background py-12 md:py-16">
      <div className="container mx-auto px-4">
        <div className="bg-muted rounded-lg p-6 md:p-10 max-w-4xl mx-auto border-l-4 border-primary shadow-md">
          <p className="text-foreground text-lg md:text-xl leading-relaxed font-default">
            UL 508A panel labeling is the set of nameplates, warning labels, and identification a UL 508A industrial control panel carries — equipment nameplates, field-wiring and warning markings, legend plates, and panel schedules. Evermark Industrial Solutions produces this marking to align with UL 508A conventions when properly specified; the panel's listing comes from the builder's own UL 508A program.
          </p>
        </div>
      </div>
    </section>;
}